import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import Logo from '../../../../assests/logo.png';
import LandscapeImg from '../../../../assests/landscape.png';
import classes from './LandscapeMessage.module.css';

const LandscapeMessage = () => {

    const [isMobile, setIsMobile] = useState(false);
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        const checkIfMobile = () => {
            const isMobileUserAgent = /Mobi|Android|iPhone|iPod|Windows Phone/i.test(navigator.userAgent);
            setIsMobile(isMobileUserAgent);
        };

        checkIfMobile();
        window.addEventListener("resize", checkIfMobile);

        return () => window.removeEventListener("resize", checkIfMobile);
    }, []);

    return (
        isMobile ? <div className={classes.LandscapeMessage} >
            <AccessibilityHiddenImg src={LandscapeImg} />
            <div className={classes.Message}>
                <AccessibilityHiddenImg src={Logo} />
                <div>{texts.landscapeMessage}</div>
            </div>
        </div> : ''
    );
}

export default LandscapeMessage;
